<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/N9fqkj/tc-custom/9781488086991.jpg?1695276167269" alt="This image is the cover for the book Warrior's Bride Prize"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Warrior's Bride Prize
      </h1>
      <p class="bookDescription body article font2">
        <b>She was gambled away—into the arms of a Roman centurion . . .</b><br/><br/>Livia Valeria is furious when she’s ruthlessly gambled away by her intended bridegroom. Luckily, it’s tall, muscled, and darkly handsome Roman centurion Marius Varro who wins her as his bride! The daughter of a slave, she must hide her Caledonian roots, but when Marius faces a barbarian rebellion at Hadrian’s Wall, Livia must make a choice: her heritage or the husband she’s falling for . . .<br/><br/><b>Acclaim for Jenni Fletcher’s <i>Captain Amberton’s Inherited Bride</i>:</b><br/><br/>“A breathtakingly pure and beautiful tale . . . Just perfect!” —<i>Chicks, Rogues and Scandals</i><br/><br/>“Fletcher takes fans on another gratifying journey.” —<i>RT Book Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jenni Fletcher
      </h2>
      
      <p class="authorDescription body article">Jenni Fletcher is the author of more than 15 historical romances, ranging from the Roman to Victorian eras because she has historical commitment issues. She has a PhD in English, has been nominated for 4 RoNA Awards and won the Libert&agrave; Books Shorter Romantic Novel Award in 2020. She grew up in Scotland and Somerset and now lives in Yorkshire with her family. In her spare time, she enjoys mountain biking, baking and, of course, reading.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6deb31d2